const classNamePrefix = 'lapidary-color-token--'

export const selectors = {
  dotToken: `${classNamePrefix}dot`,
  labelToken: `${classNamePrefix}label`,
} as const

export const cssTokenVariables = {
  borderColor: `--${classNamePrefix}border-color`,
  borderSize: `--${classNamePrefix}border-size`,
  colorBackground: `--${classNamePrefix}color-background`,
  colorForeground: `--${classNamePrefix}color-foreground`,
  hoverBorderColor: `--${classNamePrefix}hover-border-color`,
  tokenBorder: `--${classNamePrefix}token-border`,
  tokenHoverBorder: `--${classNamePrefix}token-hover-border`,
  tokenLabelHeight: `--${classNamePrefix}label-height`,
  tokenSize: `--${classNamePrefix}size`,
} as const
